import React from "react";
import Blog from "../components/Blog/Blog";

export default function BlogPage() {
  return <Blog />;
}
